module.exports = __webpack_public_path__ + "static/media/portadaIR.72fd58cf.png";